module.exports = __webpack_public_path__ + "img/news_02.9adb5505.jpg";